<div class="col col-12">
  <h5>Credit details</h5>
  <div class="col col-12">
    <ag-grid-angular style="width: 100%;height:600px"
      class="ag-theme-alpine"
      [rowData]="quoteCredits"
      [columnDefs]="creditClassColumnDefs"
      [pagination]="true"
      [defaultColDef]="defaultColDef"
      (cellClicked)="onCreditsCellClicked($event)"
      (gridReady)="onCreditsGridReady($event)">
    </ag-grid-angular>
  </div>

  <ng-container *ngIf="showPaymentGrid">
    <div class="mt-3"><h5>Payment details</h5></div>

    <div class="col col-12 mt-3">
      <ag-grid-angular style="width: 100%;height:600px"
        class="ag-theme-alpine"
        [rowData]="quoteCredits"
        [columnDefs]="paymentColumnDefs"
        [headerHeight]="64"
        [getRowStyle]="paymentPinnedRowStyle"
        [pagination]="true"
        [defaultColDef]="defaultColDef"
        (cellClicked)="onPaymentsCellClicked($event)"
        (gridReady)="onPaymentsGridReady($event)">
      </ag-grid-angular>
    </div>

    <div class="col col-12 mt-2">
      <strong>Notes:</strong>
      <span *ngIf="!isRFQAfterAmendment">
        The 'Total obligation payment excluding fees' is the sum of the 'Total Indexed Predicted price' and the 'Total Indexed Risk premium'.
      </span>
      <span *ngIf="isRFQAfterAmendment">
        The 'Obligation payment excluding fees' is the sum of the 'Predicted price per credit' and 'Risk premium per credit', multiplied by the number of credits.
      </span><br/>
      <span>
        Includes rounding therefore rounding variations may apply to the final payment amount.
      </span>
    </div>
  </ng-container>
</div>
